import { render, staticRenderFns } from "./index.vue?vue&type=template&id=edaaf67a&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=edaaf67a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edaaf67a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('edaaf67a')) {
      api.createRecord('edaaf67a', component.options)
    } else {
      api.reload('edaaf67a', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=edaaf67a&scoped=true", function () {
      api.rerender('edaaf67a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/product/product-details/firmware/index.vue"
export default component.exports